module.exports = __webpack_public_path__ + "static/media/paul_pogba_juan_mata_professional_players.67e963bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paul_pogba_juan_mata_professional_players.jpg
// module id = 926
// module chunks = 0